import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { URLS_CONST } from 'src/app/shared/constants/url-constants';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class HierarchyService {

  private accountIDSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private projectIDSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private brandDetailsSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public brandDetails$ = this.brandDetailsSubject.asObservable();

  constructor(public _utilsService: UtilsService) { }

  getHierarchyCustomSearchLevels(project_id: any, details: any) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getHierarchyLevel);
    const params: any = {}
    params[URLS_CONST.BRAND_ID] = project_id
    params[URLS_CONST.FROM_DATE] = details.from
    params[URLS_CONST.TO_DATE] = details.to
    params[URLS_CONST.PARENT_KEY] = details.parent_key
    params[URLS_CONST.PARENT_VALUE] = details.parent_value
    params[URLS_CONST.HIERARCHY_LEVEL] = details.level
    if(details.custom_filter_list) {
      params[URLS_CONST.CUSTOM_FILTER_LIST] = details.custom_filter_list.map(item => JSON.stringify(item));;
    }
    if(details.search_text) {
      params[URLS_CONST.SEARCH_TEXT] = details.search_text
    }
    return this._utilsService.getAPICall(url,this._utilsService.setHeaderWithParams(params))
  }
}
